import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomProductSummaryComponent } from './custom-product-summary.component';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';
import { OutletModule, PromotionsModule } from '@spartacus/storefront';


@NgModule({
  declarations: [CustomProductSummaryComponent],
  imports: [
    CommonModule,
    OutletModule,
    I18nModule,
    PromotionsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ProductSummaryComponent: {
          component: CustomProductSummaryComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomProductSummaryModule { }
